import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  holder: {
    gridColumn: '2 / 3',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: ({ isDirect }) => (isDirect ? '0' : '0.25rem'),
    marginRight: ({ isDirect }) => (isDirect ? '0' : '0.25rem'),
    minWidth: '60px',
    height: ({ isDirect }) => (isDirect ? '61px' : 'auto'),

    '& .MuiIconButton-root:hover': {
      backgroundColor: '#EBEEEF'
    }
  },

  inner: {
    color: '#2595D0'
  },

  avatar: {
    width: '2rem',
    height: '2rem',
    padding: '1px',
    fontSize: theme.size.sm,
    color: '#FFFFFF',
    backgroundColor: '#ADC2CC'
  }
}))

export default useStyles
